import React, { useEffect } from 'react'
import { Paragraph, Button, DialogOverlayActions, useOverlayUpdate } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'

type Props = {
  /** The groupId where the mePerson was being set to */
  groupId: string | undefined
}

/** This is the route view to show when getting an error when setting a me person. It is exported since it is used the in join flow in the group-management app.
 */
export default function SettingMePersonErrorRouteView({ groupId }: Props): JSX.Element {
  const [t] = useTranslation()
  const updateTitle = useOverlayUpdate('title')
  const updateFooter = useOverlayUpdate('footer')

  useEffect(() => {
    updateTitle(t('groups.setting-me-person-error.heading'))
  }, [t, updateTitle])

  useEffect(() => {
    updateFooter(
      <DialogOverlayActions>
        <Button
          external
          data-testid="go-to-details"
          linkName="ErrorSettingMePerson: Go To Group Details"
          to={`/groups/family/${groupId}`}
        >
          {t('groups.go-to-group-details.action')}
        </Button>
      </DialogOverlayActions>
    )
  }, [groupId, t, updateFooter])

  return <Paragraph size="sm">{t('groups.setting-me-person-error.description')}</Paragraph>
}
